import PropTypes from "prop-types";

// Shared PropTypes for records and drafts as returned by the API. Tags and
// standards may be populated objects or plain ObjectId strings.

export const tagPropType = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
]);

export const standardRefPropType = PropTypes.shape({
  standard: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  externalId: PropTypes.string,
  comment: PropTypes.string,
});

// introduced/deprecated are stored as arrays ([1, 2, 0]) but may arrive as strings
const versionPropType = PropTypes.oneOfType([
  PropTypes.array,
  PropTypes.string,
]);

export const recordPropType = PropTypes.shape({
  _id: PropTypes.string,
  ofid: PropTypes.string,
  fieldName: PropTypes.string,
  dataType: PropTypes.string,
  description: PropTypes.string,
  values: PropTypes.string,
  level: PropTypes.string,
  tags: PropTypes.arrayOf(tagPropType),
  example: PropTypes.string,
  linkReference: PropTypes.string,
  standardRefs: PropTypes.arrayOf(standardRefPropType),
  introduced: versionPropType,
  deprecated: versionPropType,
  uploadedFile: PropTypes.string,
});
